import React from "react";

import Jonathan from "./images/jonathan.jpg";

import Grid from "material-ui/Grid";

import { withStyles, createStyleSheet } from "material-ui/styles";

import { Link } from "react-router-dom";

const styleSheet = createStyleSheet("Support", (theme) => ({
  picture: {
    maxWidth: 200,
  },
}));

const Support = (props) => {
  return (
    <Grid container>
      <Grid item xs={12} sm={3} className={props.classes.picture}>
        <img src={Jonathan} alt="Jonathan" />
      </Grid>
      <Grid item xs={12} sm={9}>
        I'm Jonathan. Passionate about devops, infra, and JavaScript. I built
        Headless-Render-API.com (in service since 2016, rebranded from
        prerender.cloud 2022-05-01) to offer the market a low price, high
        performance headless browser solution (and because I love to build high
        performance stuff).
        <p>
          Please at least skim through the <Link to="/docs">docs</Link> and the{" "}
          <Link to="/docs/faq">FAQ</Link>. I also recommend reading{" "}
          <Link to="/docs/how-it-works">
            how it works, why it's needed, and caveats
          </Link>
        </p>
        <p>
          Send technical questions to <strong>{props.email}</strong> and
          include:
          <ol>
            <li>Framework version (Angular 1.x, React 14.x, etc.)</li>
            <li>a URL of the app/page in question (if possible)</li>
            <li>
              the server (Node.js, nginx, etc.) or service (Fly.io,
              CloudFront+Lambda@Edge, Netlify, etc.)
            </li>
          </ol>
        </p>
        <p>
          &mdash;{" "}
          <a
            href="https://twitter.com/jotto"
            target="_blank"
            rel="noopener noreferrer"
          >
            @jotto
          </a>{" "}
          on Twitter (but not for meaningful tech support)
        </p>
      </Grid>
    </Grid>
  );
};

export default withStyles(styleSheet)(Support);



// WEBPACK FOOTER //
// ./src/Support.js